/*
 * @Author: libo 
 * @Date: 2020-11-13 16:47:30 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 19:05:54
 */

<!--表口径新增页面-->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item has-feedback :label="$t('表口径')">
              <a-input-number :disabled="!!model.id" v-decorator="['mtCaliber', validatorRules.mtCaliber]" :placeholder="$t('请输入表口径')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <!--
          <a-col :span="12">
            <a-form-item label="口径单位">
              <j-dict-select-tag :disabled="!!model.id" v-decorator="['mtCaliberUnit',validatorRules.mtCaliberUnit]" placeholder="请选择口径单位" dictCode="mt_caliber_unit" :trigger-change="true" />
            </a-form-item>
          </a-col>
          -->
          <a-col :span="12">
            <a-form-item :label="$t('标准流量')">
              <a-input-number :disabled="disabled" v-decorator="['standFlow']" :placeholder="$t('请输入标准流量')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('最大流量')">
              <a-input-number :disabled="disabled" v-decorator="['maxFlow']" :placeholder="$t('请输入最大流量')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('日报警上限')">
              <a-input-number :disabled="disabled" v-decorator="['warnTopDay']" :placeholder="$t('请输入日报警上限')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('日报警下限')">
              <a-input-number :disabled="disabled" v-decorator="['warnLowDay']" :placeholder="$t('请输入日报警下限')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('强检年限(月)')" >
              <a-input-number :disabled="disabled" v-decorator="['ageLimitMonth']" :placeholder="$t('请输入强检年限月份表示 ')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')">
              <a-textarea :disabled="disabled" v-decorator="['remark']" rows="2" :placeholder="$t('请输入备注')" />
            </a-form-item>
          </a-col>
        </a-row>  
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import {isUndefined} from'@/utils/validate'
  import { mapGetters } from 'vuex'
  export default {
    name: 'MeterCaliberForm',
    components: {
      JFormContainer,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        url: {
          add: "/jeecg-charge/meter/meterCaliber/add",
          edit: "/jeecg-charge/meter/meterCaliber/edit",
          queryById: "/jeecg-charge/meter/meterCaliber/queryById",
          queryMtCaliberByUserId: "/jeecg-charge/meter/meterCaliber/list"
        }
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      validatorRules() {
        return {
          mtCaliber:{rules: [
            { required: true, message: this.$t('请输入表口径!') },
            {validator: this.validateMtCaliber}
          ]},
          //mtCaliberUnit:{rules: [{ required: true, message: '请选择口径单位' }]},
        }
      },
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
    },
    methods: {
      ...mapGetters(["userInfo"]),
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'mtCaliber'/*,'mtCaliberUnit'*/,'standFlow','maxFlow','warnTopDay','warnLowDay','ageLimitMonth','remark','createTime','createBy'))
        })
      }, 
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            console.log(!this.model.id);
            console.log(this.model.id);
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'mtCaliber'/*,'mtCaliberUnit'*/,'standFlow','maxFlow','warnTopDay','warnLowDay','ageLimitMonth','remark','createTime','createBy'))
      },
      validateMtCaliber(rule, value, callback){
        if(isUndefined(value)) {
          callback("")
          return
        }
        let org = this.userInfo().orgCode
        let params = {mtCaliber: this.form.getFieldValue('mtCaliber'),sysOrgCode: org}
        getAction(this.url.queryMtCaliberByUserId,params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            if(this.model.id&&res.result.records[0].id === this.model.id) {
              callback()
            }else{
              callback(this.$t("该表口径已存在!"))
            }
          } else {
            callback()
          }
        })
      }
    }
  }
</script>